"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            height: "5px",
            width: "100%",
            borderRadius: "4px"
        },
        colorPrimary: {
            backgroundColor: themes_1.materialColors.grey[200]
        },
        bar: {
            borderRadius: "4px",
            backgroundColor: themes_1.materialColors.blue[500]
        }
    });
});
